import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    // @ts-ignore
    if (window._hsq) {
      //HubSpot tracking array
      // @ts-ignore
      window._hsq.push(['setPath', location.pathname]);
      // @ts-ignore
      window._hsq.push(['trackPageView']);
    }
    // @ts-ignore
    if (window.ga) {
      //Google Analytics tracking array
      // @ts-ignore
      window.ga('set', 'page', location.pathname);
      // @ts-ignore
      window.ga('send', 'pageview');
    }
  }, [location]);
  return <></>;
}
